module.exports = __webpack_public_path__ + "img/打印纸.b77eeccd.png";